export default __webpack_public_path__ + "static/media/checkmark.3b486752.svg";